(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.abjFadeInit) return;
  window.abjFadeInit = true;
  var els = document.querySelectorAll('.abj-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('abj-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  // Failsafe: force reveal regardless, in case the observer never fires.
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-newsletter-signup"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.abjFadeInit) return;
  window.abjFadeInit = true;
  var els = document.querySelectorAll('.abj-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('abj-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bigger-picture"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.abjFadeInit) return;
  window.abjFadeInit = true;
  var els = document.querySelectorAll('.abj-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('abj-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-before-you-head-out"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

(function(){
  if (window.bjfAccordionInit) return;
  window.bjfAccordionInit = true;
  document.querySelectorAll('.bjf-faq-q').forEach(function(q){
    q.addEventListener('touchstart', function(){ q.style.color = '#1EB8BA'; }, {passive: true});
    q.addEventListener('touchend', function(){ setTimeout(function(){ q.style.color = ''; }, 300); }, {passive: true});
    q.addEventListener('click', function(){
      var item = q.parentElement;
      var isOpen = item.classList.contains('open');
      var list = item.closest('.bjf-byho-list');
      if (list) {
        list.querySelectorAll('.bjf-faq-item').forEach(function(i){ i.classList.remove('open'); });
      }
      if (!isOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      } else {
        q.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero-form"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

(function(){
  if (window.bjfAccordionInit) return;
  window.bjfAccordionInit = true;
  document.querySelectorAll('.bjf-faq-q').forEach(function(q){
    q.addEventListener('touchstart', function(){ q.style.color = '#1EB8BA'; }, {passive: true});
    q.addEventListener('touchend', function(){ setTimeout(function(){ q.style.color = ''; }, 300); }, {passive: true});
    q.addEventListener('click', function(){
      var item = q.parentElement;
      var isOpen = item.classList.contains('open');
      var list = item.closest('.bjf-faq-list');
      if (list) {
        list.querySelectorAll('.bjf-faq-item').forEach(function(i){ i.classList.remove('open'); });
      }
      if (!isOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      } else {
        q.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-not-sure-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-trust-badges"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.bjfFadeInit) return;
  window.bjfFadeInit = true;
  var els = document.querySelectorAll('.bjf-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('bjf-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hammock-family"]) return;
  try {
    
(function(){

  var cur=1;
  var slidesEl=document.getElementById('bjhfSlides');
  var total=parseInt((slidesEl&&slidesEl.dataset.count)||'1',10);
  function getW(){return slidesEl?Math.round(slidesEl.getBoundingClientRect().width):0;}
  function goTo(n,animate){var w=getW();if(!w){setTimeout(function(){goTo(n,animate);},200);return;}n=Math.max(1,Math.min(n,total));cur=n;if(animate===false){slidesEl.style.scrollBehavior='auto';slidesEl.scrollLeft=(cur-1)*w;slidesEl.style.scrollBehavior='';}else{slidesEl.scrollTo({left:(cur-1)*w,behavior:'smooth'});}var c=document.getElementById('bjhfCount');if(c)c.textContent=cur+' / '+total;document.querySelectorAll('#bjhfThumbsGrid .bjhf-thumb').forEach(function(t,i){t.classList.toggle('active',i===(cur-1));});var th=document.querySelectorAll('#bjhfThumbsGrid .bjhf-thumb')[cur-1];if(th)th.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
  var touchStartX=0,touchStartY=0,galleryDragging=false;
  if(slidesEl){slidesEl.addEventListener('touchstart',function(e){touchStartX=e.touches[0].clientX;touchStartY=e.touches[0].clientY;galleryDragging=false;},{passive:true});slidesEl.addEventListener('touchmove',function(e){var dx=Math.abs(e.touches[0].clientX-touchStartX);var dy=Math.abs(e.touches[0].clientY-touchStartY);if(dx>dy&&dx>8){galleryDragging=true;}},{passive:true});slidesEl.addEventListener('touchend',function(e){if(!galleryDragging)return;var diff=touchStartX-e.changedTouches[0].clientX;if(Math.abs(diff)>40){diff>0?goTo(cur+1,true):goTo(cur-1,true);}},{passive:true});var scrollTimer=null;slidesEl.addEventListener('scroll',function(){clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){var w=getW();if(!w)return;var idx=Math.round(slidesEl.scrollLeft/w)+1;if(idx>=1&&idx<=total&&idx!==cur){cur=idx;var c=document.getElementById('bjhfCount');if(c)c.textContent=cur+' / '+total;document.querySelectorAll('#bjhfThumbsGrid .bjhf-thumb').forEach(function(t,i){t.classList.toggle('active',i===(cur-1));});}},80);},{passive:true});}
  if(slidesEl){var wheelTimer=null;slidesEl.addEventListener('wheel',function(e){if(Math.abs(e.deltaX)>Math.abs(e.deltaY)){return;}if(Math.abs(e.deltaY)<2)return;e.preventDefault();clearTimeout(wheelTimer);wheelTimer=setTimeout(function(){goTo(e.deltaY>0?cur+1:cur-1,true);},60);},{passive:false});}
  requestAnimationFrame(function(){goTo(1,false);});
  var pb=document.getElementById('bjhfPrevBtn'),nb=document.getElementById('bjhfNextBtn');
  if(pb)pb.addEventListener('click',function(){goTo(cur-1,true);});
  if(nb)nb.addEventListener('click',function(){goTo(cur+1,true);});
  document.querySelectorAll('#bjhfThumbsGrid .bjhf-thumb').forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(t.dataset.index)+1,true);});});
  document.addEventListener('keydown',function(e){if(e.key==='ArrowRight')goTo(cur+1,true);if(e.key==='ArrowLeft')goTo(cur-1,true);});
  var variantBtns=document.querySelectorAll('.bjhf-variant-btn');var variantIdInput=document.getElementById('bjhfVariantId');var variantSelectedLabel=document.getElementById('bjhfVariantSelected');var lightbox=document.getElementById('bjhfLightbox');var lightboxImg=document.getElementById('bjhfLightboxImg');var lightboxClose=document.getElementById('bjhfLightboxClose');
  if(variantIdInput){var rightBtn=document.querySelector('.bjhf-variant-btn.active');if(rightBtn)variantIdInput.value=rightBtn.dataset.variantId;}
  variantBtns.forEach(function(btn){btn.addEventListener('click',function(e){if(e.target.closest('.bjhf-variant-enlarge'))return;variantBtns.forEach(function(b){b.classList.remove('active');});btn.classList.add('active');if(variantIdInput)variantIdInput.value=btn.dataset.variantId;if(variantSelectedLabel)variantSelectedLabel.textContent='('+btn.dataset.variantTitle+' selected)';});});
  variantBtns.forEach(function(btn){var enlarge=btn.querySelector('.bjhf-variant-enlarge');if(enlarge){enlarge.addEventListener('click',function(e){e.stopPropagation();if(lightboxImg)lightboxImg.src=btn.dataset.lightboxSrc;if(lightbox)lightbox.classList.add('open');});}});
  function closeLightbox(){if(lightbox)lightbox.classList.remove('open');}
  if(lightboxClose)lightboxClose.addEventListener('click',closeLightbox);
  if(lightbox)lightbox.addEventListener('click',function(e){if(e.target===lightbox)closeLightbox();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLightbox();});
  (function(){
    var panelsWrap=document.getElementById('bjhfCmpPanels');if(!panelsWrap)return;
    var panels=panelsWrap.querySelectorAll('.bjhf-cmp-panel');
    var tabs=document.querySelectorAll('.bjhf-cmp-tab');
    function sizePanels(){
      var maxH=0;
      panels.forEach(function(p){
        var pd=p.style.position,pv=p.style.visibility,pdisp=p.style.display;
        p.style.position='absolute';p.style.visibility='hidden';p.style.display='block';
        maxH=Math.max(maxH,p.scrollHeight);
        p.style.position=pd;p.style.visibility=pv;p.style.display=pdisp;
      });
      panelsWrap.style.minHeight=maxH+'px';
    }
    function showCmpTab(i){
      panels.forEach(function(p,idx){p.classList.toggle('active',idx===i);});
      tabs.forEach(function(t,idx){t.classList.toggle('active',idx===i);});
    }
    tabs.forEach(function(t,idx){t.addEventListener('click',function(){showCmpTab(idx);});});
    sizePanels();
    window.addEventListener('resize',sizePanels);
  })();
  var explainEnlarge=document.getElementById('bjhfExplainEnlarge');
  if(explainEnlarge){
    var openExplainLightbox=function(e){e.stopPropagation();if(lightboxImg)lightboxImg.src=explainEnlarge.dataset.lightboxSrc;if(lightbox)lightbox.classList.add('open');};
    explainEnlarge.addEventListener('click',openExplainLightbox);
    explainEnlarge.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openExplainLightbox(e);}});
  }
  var qm=document.getElementById('bjhfQtyMinus'),qp=document.getElementById('bjhfQtyPlus');
  if(qm)qm.addEventListener('click',function(){var i=document.getElementById('bjhfQty'),h=document.getElementById('bjhfQtyInput'),v=Math.max(1,parseInt(i.value)-1);i.value=v;if(h)h.value=v;});
  if(qp)qp.addEventListener('click',function(){var i=document.getElementById('bjhfQty'),h=document.getElementById('bjhfQtyInput'),v=parseInt(i.value)+1;i.value=v;if(h)h.value=v;});
  document.querySelectorAll('.bjhf-accord-q,.bjhf-faq-q').forEach(function(q){q.addEventListener('touchstart',function(){q.style.color='var(--teal)';},{passive:true});q.addEventListener('touchend',function(){setTimeout(function(){q.style.color='';},300);},{passive:true});q.addEventListener('click',function(){var item=q.parentElement,isOpen=item.classList.contains('open');var list=item.closest('.bjhf-accords,.bjhf-faq-list');if(list)list.querySelectorAll('.bjhf-accord-item,.bjhf-faq-item').forEach(function(i){i.classList.remove('open');});if(!isOpen)item.classList.add('open');});});
  function bjhfScrollToTop(){var pw=document.querySelector('.page-wrapper');if(pw&&pw.scrollHeight>pw.clientHeight+2){pw.scrollTo({top:0,behavior:'instant'});}else{window.scrollTo({top:0,behavior:'instant'});}}
  var guarBtn=document.getElementById('bjhfGuarShopNowBtn');if(guarBtn)guarBtn.addEventListener('click',bjhfScrollToTop);
  document.querySelectorAll('.bjhf-footer-banner-desk button, .bjhf-footer-banner-mobile button').forEach(function(fb){fb.removeAttribute('onclick');fb.addEventListener('click',bjhfScrollToTop);});
  var vWrap=document.getElementById('bjhfVideoWrap');
  if(vWrap){
    vWrap.addEventListener('click',function(){
      if(vWrap.classList.contains('playing'))return;
      var vid=document.getElementById('bjhfVideoEl');
      if(!vid)return;
      var srcEl=vid.querySelector('source');
      if(srcEl&&srcEl.dataset.src&&!srcEl.src){srcEl.src=srcEl.dataset.src;vid.load();}
      vWrap.classList.add('playing');
      var pp=vid.play();
      if(pp!==undefined){pp.catch(function(){});}
    });
  }
})();
(function(){
  function drawDeskTimeline(){var dCont=document.getElementById('bjhfDeskTimeline');var dSvg=document.getElementById('bjhfDeskSvg');if(!dCont||!dSvg||window.getComputedStyle(dCont).display==='none')return;var dR=dCont.getBoundingClientRect();if(!dR.width)return;var dIds=['bjhfDeskCircle1','bjhfDeskCircle2','bjhfDeskCircle3','bjhfDeskCircle4'];var dC=dIds.map(function(id){var el=document.getElementById(id);if(!el)return null;var r=el.getBoundingClientRect();if(!r.width)return null;return{cx:r.left-dR.left+r.width/2,cy:r.top-dR.top+r.height/2,r:r.width/2};}).filter(Boolean);if(dC.length<4)return;dSvg.setAttribute('width',dCont.offsetWidth);dSvg.setAttribute('height',dCont.offsetHeight);dSvg.innerHTML='';var bows=[-55,55,-55];var d='M '+(dC[0].cx+dC[0].r+2).toFixed(1)+' '+dC[0].cy.toFixed(1);for(var j=0;j<3;j++){var da=dC[j],db=dC[j+1];var ex=da.cx+da.r+2,ey=da.cy,nx=db.cx-db.r-2,ny=db.cy,bow=bows[j],span=nx-ex;var cp1x=(ex+span*0.4).toFixed(1),cp1y=(ey+bow).toFixed(1);var cp2x=(nx-span*0.4).toFixed(1),cp2y=(ny+bow).toFixed(1);d+=' C '+cp1x+' '+cp1y+', '+cp2x+' '+cp2y+', '+nx.toFixed(1)+' '+ny.toFixed(1);if(j<2)d+=' L '+(db.cx+db.r+2).toFixed(1)+' '+db.cy.toFixed(1);}var p=document.createElementNS('http://www.w3.org/2000/svg','path');p.setAttribute('d',d);p.setAttribute('stroke','#1EB8BA');p.setAttribute('stroke-width','3');p.setAttribute('fill','none');p.setAttribute('stroke-dasharray','10,6');p.setAttribute('stroke-linecap','round');p.setAttribute('stroke-linejoin','round');dSvg.appendChild(p);}
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){window.addEventListener('load',drawDeskTimeline);drawDeskTimeline();});}else{window.addEventListener('load',drawDeskTimeline);}
  var bjhfFamTimelineResizeTimer=null;window.addEventListener('resize',function(){clearTimeout(bjhfFamTimelineResizeTimer);bjhfFamTimelineResizeTimer=setTimeout(drawDeskTimeline,150);});
})();
(function(){
  var fc=0,fStart=0,fStartY=0,fSwiping=false;
  var fSlidesEl=document.getElementById('bjhfFeatSlides');
  var fTotal=parseInt((fSlidesEl&&fSlidesEl.dataset.count)||'0',10);
  function featGoTo(n){if(!fTotal)return;fc=((n%fTotal)+fTotal)%fTotal;var sl=document.getElementById('bjhfFeatSlides');if(sl)sl.style.transform='translateX(-'+(fc*100)+'%)';document.querySelectorAll('.bjhf-feat-dot').forEach(function(d,i){d.classList.toggle('active',i===fc);});}
  document.querySelectorAll('.bjhf-feat-dot').forEach(function(d){d.addEventListener('click',function(){featGoTo(parseInt(d.dataset.feat));});});
  var fcEl=document.getElementById('bjhfFeatCar');if(fcEl){fcEl.addEventListener('touchstart',function(e){fStart=e.touches[0].clientX;fStartY=e.touches[0].clientY;fSwiping=false;},{passive:true});fcEl.addEventListener('touchmove',function(e){var dx=Math.abs(e.touches[0].clientX-fStart);var dy=Math.abs(e.touches[0].clientY-fStartY);if(dx>dy&&dx>10){fSwiping=true;e.preventDefault();}},{passive:false});fcEl.addEventListener('touchend',function(e){if(!fSwiping)return;var d=fStart-e.changedTouches[0].clientX;if(Math.abs(d)>40){d>0?featGoTo(fc+1):featGoTo(fc-1);}fSwiping=false;});}
})();
(function(){
  var s=document.getElementById('bjhfSticky');if(!s)return;
  var shown=false;
  var hideZoneActive=false;
  function upd(){var shouldShow=window.scrollY>300&&!hideZoneActive;if(shouldShow&&!shown){s.classList.add('visible');shown=true;}else if(!shouldShow&&shown){s.classList.remove('visible');shown=false;}}
  var hideZones=Array.prototype.slice.call(document.querySelectorAll('.bjhf-guar, .bjhf-footer-banner-desk, .bjhf-footer-banner-mobile'));
  if('IntersectionObserver' in window && hideZones.length){
    var visibleZones=new Set();
    var hideObs=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){visibleZones.add(en.target);}else{visibleZones.delete(en.target);}});
      hideZoneActive=visibleZones.size>0;
      upd();
    },{threshold:0.15});
    hideZones.forEach(function(z){hideObs.observe(z);});
  }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('load',upd);
  setTimeout(upd,500);
})();
(function(){
  var steps=document.querySelectorAll('.bjhf-tick-item');
  if(!steps.length)return;
  if(!('IntersectionObserver' in window)){steps.forEach(function(s){s.classList.add('is-visible');});return;}
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-visible');obs.unobserve(en.target);}});
  },{threshold:0.35});
  steps.forEach(function(s){obs.observe(s);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hammock"]) return;
  try {
    
(function(){

  var cur=1;
  var slidesEl=document.getElementById('bjSlides');
  var total=parseInt((slidesEl&&slidesEl.dataset.count)||'1',10);
  function getW(){return slidesEl?Math.round(slidesEl.getBoundingClientRect().width):0;}
  function goTo(n,animate){var w=getW();if(!w){setTimeout(function(){goTo(n,animate);},200);return;}n=Math.max(1,Math.min(n,total));cur=n;if(animate===false){slidesEl.style.scrollBehavior='auto';slidesEl.scrollLeft=(cur-1)*w;slidesEl.style.scrollBehavior='';}else{slidesEl.scrollTo({left:(cur-1)*w,behavior:'smooth'});}var c=document.getElementById('bjCount');if(c)c.textContent=cur+' / '+total;document.querySelectorAll('#bjThumbsGrid .bj-thumb').forEach(function(t,i){t.classList.toggle('active',i===(cur-1));});var th=document.querySelectorAll('#bjThumbsGrid .bj-thumb')[cur-1];if(th)th.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
  var touchStartX=0,touchStartY=0,galleryDragging=false;
  if(slidesEl){slidesEl.addEventListener('touchstart',function(e){touchStartX=e.touches[0].clientX;touchStartY=e.touches[0].clientY;galleryDragging=false;},{passive:true});slidesEl.addEventListener('touchmove',function(e){var dx=Math.abs(e.touches[0].clientX-touchStartX);var dy=Math.abs(e.touches[0].clientY-touchStartY);if(dx>dy&&dx>8){galleryDragging=true;}},{passive:true});slidesEl.addEventListener('touchend',function(e){if(!galleryDragging)return;var diff=touchStartX-e.changedTouches[0].clientX;if(Math.abs(diff)>40){diff>0?goTo(cur+1,true):goTo(cur-1,true);}},{passive:true});var scrollTimer=null;slidesEl.addEventListener('scroll',function(){clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){var w=getW();if(!w)return;var idx=Math.round(slidesEl.scrollLeft/w)+1;if(idx>=1&&idx<=total&&idx!==cur){cur=idx;var c=document.getElementById('bjCount');if(c)c.textContent=cur+' / '+total;document.querySelectorAll('#bjThumbsGrid .bj-thumb').forEach(function(t,i){t.classList.toggle('active',i===(cur-1));});}},80);},{passive:true});}
  if(slidesEl){var wheelTimer=null;slidesEl.addEventListener('wheel',function(e){if(Math.abs(e.deltaX)>Math.abs(e.deltaY)){return;}if(Math.abs(e.deltaY)<2)return;e.preventDefault();clearTimeout(wheelTimer);wheelTimer=setTimeout(function(){goTo(e.deltaY>0?cur+1:cur-1,true);},60);},{passive:false});}
  requestAnimationFrame(function(){goTo(1,false);});
  var pb=document.getElementById('bjPrevBtn'),nb=document.getElementById('bjNextBtn');
  if(pb)pb.addEventListener('click',function(){goTo(cur-1,true);});
  if(nb)nb.addEventListener('click',function(){goTo(cur+1,true);});
  document.querySelectorAll('#bjThumbsGrid .bj-thumb').forEach(function(t){t.addEventListener('click',function(){goTo(parseInt(t.dataset.index)+1,true);});});
  document.addEventListener('keydown',function(e){if(e.key==='ArrowRight')goTo(cur+1,true);if(e.key==='ArrowLeft')goTo(cur-1,true);});
  function handleBubba(){var mob=document.getElementById('bjBubbaMobile');var desk=document.getElementById('bjBubbaDesktop');if(!mob||!desk)return;if(window.innerWidth>=900){mob.style.display='none';desk.style.display='flex';}else{mob.style.display='flex';desk.style.display='none';}}
  handleBubba();window.addEventListener('resize',handleBubba);
  var variantBtns=document.querySelectorAll('.bj-variant-btn');var variantIdInput=document.getElementById('bjVariantId');var variantSelectedLabel=document.getElementById('bjVariantSelected');var lightbox=document.getElementById('bjLightbox');var lightboxImg=document.getElementById('bjLightboxImg');var lightboxClose=document.getElementById('bjLightboxClose');
  if(variantIdInput){var rightBtn=document.querySelector('.bj-variant-btn.active');if(rightBtn)variantIdInput.value=rightBtn.dataset.variantId;}
  variantBtns.forEach(function(btn){btn.addEventListener('click',function(e){if(e.target.closest('.bj-variant-enlarge'))return;variantBtns.forEach(function(b){b.classList.remove('active');});btn.classList.add('active');if(variantIdInput)variantIdInput.value=btn.dataset.variantId;if(variantSelectedLabel)variantSelectedLabel.textContent=btn.dataset.variantTitle+' selected';});});
  variantBtns.forEach(function(btn){var enlarge=btn.querySelector('.bj-variant-enlarge');if(enlarge){enlarge.addEventListener('click',function(e){e.stopPropagation();if(lightboxImg)lightboxImg.src=btn.dataset.lightboxSrc;if(lightbox)lightbox.classList.add('open');});}});
  function closeLightbox(){if(lightbox)lightbox.classList.remove('open');}
  if(lightboxClose)lightboxClose.addEventListener('click',closeLightbox);
  if(lightbox)lightbox.addEventListener('click',function(e){if(e.target===lightbox)closeLightbox();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLightbox();});
  document.querySelectorAll('.bj-flip-card').forEach(function(card){function toggle(){card.classList.toggle('flipped');}card.addEventListener('click',toggle);card.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')toggle();});});
  var qm=document.getElementById('bjQtyMinus'),qp=document.getElementById('bjQtyPlus');
  if(qm)qm.addEventListener('click',function(){var i=document.getElementById('bjQty'),h=document.getElementById('bjQtyInput'),v=Math.max(1,parseInt(i.value)-1);i.value=v;if(h)h.value=v;});
  if(qp)qp.addEventListener('click',function(){var i=document.getElementById('bjQty'),h=document.getElementById('bjQtyInput'),v=parseInt(i.value)+1;i.value=v;if(h)h.value=v;});
  document.querySelectorAll('.bj-accord-q,.bj-faq-q').forEach(function(q){q.addEventListener('touchstart',function(){q.style.color='var(--teal)';},{passive:true});q.addEventListener('touchend',function(){setTimeout(function(){q.style.color='';},300);},{passive:true});q.addEventListener('click',function(){var item=q.parentElement,isOpen=item.classList.contains('open');var list=item.closest('.bj-accords,.bj-faq-list');if(list)list.querySelectorAll('.bj-accord-item,.bj-faq-item').forEach(function(i){i.classList.remove('open');});if(!isOpen)item.classList.add('open');});});
  function bjScrollToTop(){var pw=document.querySelector('.page-wrapper');if(pw&&pw.scrollHeight>pw.clientHeight+2){pw.scrollTo({top:0,behavior:'instant'});}else{window.scrollTo({top:0,behavior:'instant'});}}
  var guarBtn=document.getElementById('bjGuarShopNowBtn');if(guarBtn)guarBtn.addEventListener('click',bjScrollToTop);
  document.querySelectorAll('.bj-footer-banner-desk button, .bj-footer-banner-mobile button').forEach(function(fb){fb.removeAttribute('onclick');fb.addEventListener('click',bjScrollToTop);});
  function drawDeskTimeline(){var dCont=document.getElementById('bjDeskTimeline');var dSvg=document.getElementById('bjDeskSvg');if(!dCont||!dSvg||window.getComputedStyle(dCont).display==='none')return;var dR=dCont.getBoundingClientRect();if(!dR.width)return;var dIds=['bjDeskCircle1','bjDeskCircle2','bjDeskCircle3','bjDeskCircle4'];var dC=dIds.map(function(id){var el=document.getElementById(id);if(!el)return null;var r=el.getBoundingClientRect();if(!r.width)return null;return{cx:r.left-dR.left+r.width/2,cy:r.top-dR.top+r.height/2,r:r.width/2};}).filter(Boolean);if(dC.length<4)return;dSvg.setAttribute('width',dCont.offsetWidth);dSvg.setAttribute('height',dCont.offsetHeight);dSvg.innerHTML='';var bows=[-55,55,-55];var d='M '+(dC[0].cx+dC[0].r+2).toFixed(1)+' '+dC[0].cy.toFixed(1);for(var j=0;j<3;j++){var da=dC[j],db=dC[j+1];var ex=da.cx+da.r+2,ey=da.cy,nx=db.cx-db.r-2,ny=db.cy,bow=bows[j],span=nx-ex;var cp1x=(ex+span*0.4).toFixed(1),cp1y=(ey+bow).toFixed(1);var cp2x=(nx-span*0.4).toFixed(1),cp2y=(ny+bow).toFixed(1);d+=' C '+cp1x+' '+cp1y+', '+cp2x+' '+cp2y+', '+nx.toFixed(1)+' '+ny.toFixed(1);if(j<2)d+=' L '+(db.cx+db.r+2).toFixed(1)+' '+db.cy.toFixed(1);}var p=document.createElementNS('http://www.w3.org/2000/svg','path');p.setAttribute('d',d);p.setAttribute('stroke','#1EB8BA');p.setAttribute('stroke-width','3');p.setAttribute('fill','none');p.setAttribute('stroke-dasharray','10,6');p.setAttribute('stroke-linecap','round');p.setAttribute('stroke-linejoin','round');dSvg.appendChild(p);}
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){window.addEventListener('load',drawDeskTimeline);drawDeskTimeline();});}else{window.addEventListener('load',drawDeskTimeline);}
  var resizeTimer=null;window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(drawDeskTimeline,150);});
  var vWrap=document.getElementById('bjVideoWrap');
  if(vWrap){
    vWrap.addEventListener('click',function(){
      if(vWrap.classList.contains('playing'))return;
      var vid=document.getElementById('bjVideoEl');
      if(!vid)return;
      var srcEl=vid.querySelector('source');
      if(srcEl&&srcEl.dataset.src&&!srcEl.src){srcEl.src=srcEl.dataset.src;vid.load();}
      vWrap.classList.add('playing');
      var pp=vid.play();
      if(pp!==undefined){pp.catch(function(){});}
    });
  }
})();
(function(){
  var fc=0,fStart=0,fStartY=0,fSwiping=false;
  function featGoTo(n){fc=((n%6)+6)%6;var sl=document.getElementById('bjFeatSlides');if(sl)sl.style.transform='translateX(-'+(fc*100)+'%)';document.querySelectorAll('.bj-feat-dot').forEach(function(d,i){d.classList.toggle('active',i===fc);});}
  document.querySelectorAll('.bj-feat-dot').forEach(function(d){d.addEventListener('click',function(){featGoTo(parseInt(d.dataset.feat));});});
  var fcEl=document.getElementById('bjFeatCar');if(fcEl){fcEl.addEventListener('touchstart',function(e){fStart=e.touches[0].clientX;fStartY=e.touches[0].clientY;fSwiping=false;},{passive:true});fcEl.addEventListener('touchmove',function(e){var dx=Math.abs(e.touches[0].clientX-fStart);var dy=Math.abs(e.touches[0].clientY-fStartY);if(dx>dy&&dx>10){fSwiping=true;e.preventDefault();}},{passive:false});fcEl.addEventListener('touchend',function(e){if(!fSwiping)return;var d=fStart-e.changedTouches[0].clientX;if(Math.abs(d)>40){d>0?featGoTo(fc+1):featGoTo(fc-1);}fSwiping=false;});}
  var tc=0,tStart=0,tStartY=0,tSwiping=false;
  function testGoTo(n){tc=((n%4)+4)%4;var sl=document.getElementById('bjTestSlides');if(sl)sl.style.transform='translateX(-'+(tc*100)+'%)';document.querySelectorAll('.bj-test-dot').forEach(function(d,i){d.classList.toggle('active',i===tc);});}
  document.querySelectorAll('.bj-test-dot').forEach(function(d){d.addEventListener('click',function(){testGoTo(parseInt(d.dataset.test));});});
  var tcEl=document.getElementById('bjTestCar');if(tcEl){tcEl.addEventListener('touchstart',function(e){tStart=e.touches[0].clientX;tStartY=e.touches[0].clientY;tSwiping=false;},{passive:true});tcEl.addEventListener('touchmove',function(e){var dx=Math.abs(e.touches[0].clientX-tStart);var dy=Math.abs(e.touches[0].clientY-tStartY);if(dx>dy&&dx>10){tSwiping=true;e.preventDefault();}},{passive:false});tcEl.addEventListener('touchend',function(e){if(!tSwiping)return;var d=tStart-e.changedTouches[0].clientX;if(Math.abs(d)>40){d>0?testGoTo(tc+1):testGoTo(tc-1);}tSwiping=false;});}
})();
(function(){
  var s=document.getElementById('bjSticky');if(!s)return;
  var shown=false;
  var hideZoneActive=false;
  function upd(){var shouldShow=window.scrollY>300&&!hideZoneActive;if(shouldShow&&!shown){s.classList.add('visible');shown=true;}else if(!shouldShow&&shown){s.classList.remove('visible');shown=false;}}
  var hideZones=Array.prototype.slice.call(document.querySelectorAll('.bj-guar, .bj-footer-banner-desk, .bj-footer-banner-mobile'));
  if('IntersectionObserver' in window && hideZones.length){
    var visibleZones=new Set();
    var hideObs=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){visibleZones.add(en.target);}else{visibleZones.delete(en.target);}});
      hideZoneActive=visibleZones.size>0;
      upd();
    },{threshold:0.15});
    hideZones.forEach(function(z){hideObs.observe(z);});
  }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('load',upd);
  setTimeout(upd,500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-matters"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.abjFadeInit) return;
  window.abjFadeInit = true;
  var els = document.querySelectorAll('.abj-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('abj-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-we-exist"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.abjFadeInit) return;
  window.abjFadeInit = true;
  var els = document.querySelectorAll('.abj-fade');
  if (!els.length) return;
  els.forEach(function(el){ el.classList.add('abj-fade-js'); });
  var reveal = function(el){ el.classList.add('visible'); };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, {threshold: 0.1});
    els.forEach(function(el){ io.observe(el); });
  } else {
    els.forEach(reveal);
  }
  setTimeout(function(){ els.forEach(reveal); }, 2500);
})();

  } catch(e) { console.error(e); }
})();
})();
